import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../lib/utils';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import {
  BarChart3,
  TrendingUp,
  BarChart2,
  PieChart,
  PackageOpen,
} from 'lucide-react';
import Layout from '../components/Layout';

const ReportsPage = () => {
  const navigate = useNavigate();

  const reportCards = [
    {
      key: 'bar-stock-consumption',
      icon: PackageOpen,
      iconColor: 'text-primary',
      title: '棒料采购消耗报表',
      description: '按采购合同追踪棒料入库、领用与库存',
      buttonText: '查看报表',
      buttonVariant: 'default',
      path: '/reports/bar-stock-consumption',
    },
    {
      key: 'quality-capacity',
      icon: BarChart3,
      iconColor: 'text-primary',
      title: '质量与产能报表',
      description: '按时间统计生产完成、报废数量、良率及产值',
      buttonText: '查看报表',
      buttonVariant: 'outline',
      path: '/reports/quality-capacity',
    },
    {
      key: 'sales',
      icon: TrendingUp,
      iconColor: 'text-primary',
      title: 'Sales Report',
      description: 'Generate sales performance reports',
      buttonText: 'Generate',
      buttonVariant: 'outline',
      path: null,
    },
    {
      key: 'inventory',
      icon: BarChart2,
      iconColor: 'text-success',
      title: 'Inventory Report',
      description: 'View inventory status and trends',
      buttonText: 'View Report',
      buttonVariant: 'outline',
      path: null,
    },
    {
      key: 'financial',
      icon: PieChart,
      iconColor: 'text-warning',
      title: 'Financial Report',
      description: 'Financial performance analysis',
      buttonText: 'Generate',
      buttonVariant: 'outline',
      path: null,
    },
  ];

  return (
    <Layout title="报表统计" activeTab="reports">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 bg-muted/30 min-h-full">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">
            Reports & Analytics
          </h1>
          <p className="text-muted-foreground">
            Generate insights and reports for your business operations
          </p>
        </div>

        {/* Quick Actions */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {reportCards.map((card) => {
            const IconComponent = card.icon;
            return (
              <Card key={card.key} className="border bg-card">
                <CardContent className="pt-6 text-center">
                  <IconComponent className={cn("h-12 w-12 mx-auto mb-4", card.iconColor)} />
                  <h3 className="text-lg font-semibold mb-1">{card.title}</h3>
                  <p className="text-sm text-muted-foreground mb-4">{card.description}</p>
                  <Button
                    variant={card.buttonVariant}
                    size="sm"
                    className={cn(
                      card.buttonVariant === 'default' && 'bg-primary text-primary-foreground',
                    )}
                    onClick={() => {
                      if (card.path) {
                        navigate(card.path);
                      }
                    }}
                  >
                    {card.buttonText}
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Coming Soon Message */}
        <Card className="border bg-card">
          <CardContent className="py-12 text-center">
            <BarChart3 className="h-16 w-16 mx-auto mb-4 text-muted-foreground/50" />
            <h2 className="text-2xl font-semibold mb-3 text-foreground">
              Reports Module Coming Soon
            </h2>
            <p className="text-muted-foreground mb-6">
              This page is currently under development. Advanced reporting and analytics features will be available soon.
            </p>
            <Button onClick={() => navigate('/dashboard')}>
              Back to Dashboard
            </Button>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default ReportsPage;
